// OrganizationsListPage.js
import React, { useState } from 'react';

import Banner from '../../b2b-common/Banner';
import OrganizationDetailsModal from '../forms/OrganizationDetailsModal';


import './OrganizationsListPage.css';
import SearchOrganizationsPaged from '../components/organization/SearchOrganizationsPaged';

const OrganizationsListPage = () => {
    const [selectedOrganization, setSelectedOrganization] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [refresh, setRefresh] = useState(true);

    const handleSelectOrganization = (organization) => {
        setSelectedOrganization(organization);
        setRefresh(false);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setRefresh(true);
        setIsModalOpen(false);
    };

    const handleUpdateOrganization = (updatedOrganization) => {
        setRefresh(true);
        setSelectedOrganization(updatedOrganization);
    };

    return (
        <React.Fragment>
            <div className="organizations-list-page-container">
                <Banner message="Users Menu: List current organizations" />

                <SearchOrganizationsPaged
                    uuidsBlacklist={null}
                    elementsPerPage={15}
                    forceRefresh={refresh}
                    onSelectedOrganization={handleSelectOrganization}
                    className='organizations-list-search'
                />
                <OrganizationDetailsModal
                    open={isModalOpen}
                    organization={selectedOrganization || {}}
                    canEdit={true}
                    onClose={handleCloseModal}
                    onDeleteOrganization={(organization) => {
                        handleUpdateOrganization(organization);
                    }}
                    onUpdateOrganization={(organization) => {
                        handleUpdateOrganization(organization);
                    }}
                />
            </div>
        </React.Fragment>
    );
};

export default OrganizationsListPage;